<template>
  <v-dialog v-model="dialog" width="600px">
    <v-card>
      <p class=".title ma-2">Transfer points</p>
      <v-form ref="transferKlpt" v-model="transferKlptValid">
        <v-row no-gutters>
          <v-col class="ma-2">
            <v-text-field v-model="klpt_punten" :label="punten_label" :rules="klpt_puntenRule"></v-text-field>
            <v-select v-model="klpt_booking" :items="klpt.huov_list" item-value="huov_code" item-text="huov_description" label="Transfer (part of the) points to booking..." clearable :rules="huov_rule"></v-select>
          </v-col>
        </v-row>  
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary mx-2" small @click="transferKlpt" :disabled="!transferKlptValid" :loading="loading">Transfer</v-btn>
        <v-btn color="primary" small @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  data() { 
    return {
      dialog: false,
      transferKlptValid: false,
      huov_encrid : null,
      klpt_punten: '',
      klpt_booking: '',
      klpt: {},
      punten_label: '',
      klpt_current: 0,
      loading: false,
      huov_rule: [
        v => (v && v.length >= 1) || "A booking is required"
      ],
      klpt_puntenRule: [
        v => !!v || 'Points are mandatory',
        v => /^\d+$/.test(v) || 'Must be a whole number only (no decimals or letters)',
        v => parseInt(v) > 0 || 'Must be greater than 0',
        v => parseInt(v) <= this.klpt_current || `Cannot exceed ${this.klpt_current} points`
      ],
    }
  },
  methods: {
    open(huov_encrid) {
      this.$emit("showSnackbar");
      this.huov_encrid = huov_encrid;
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/klpt/getKlptTransferInfo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getKlptTransferInfo"
          },
          getKlptTransferInfo: {
            huov_encrid: huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.klpt = res.data.getKlptTransferInfo;
            this.klpt_current = this.klpt.klpt_current;
            this.getLabel();
          }
        })
    },
    getLabel() {
      this.punten_label = `Points (Max: ${this.klpt_current})`;
    },
    transferKlpt() { 
      this.loading = true;
      this.$axios
        .post("ares/json/ares/huov/klpt/transferKlpt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "transferKlpt"
          },
          transferKlpt: {
            huov_encrid: this.huov_encrid,
            klpt_punten: parseInt(this.klpt_punten),
            klpt_booking: this.klpt_booking
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.loading = false;
          } else { 
            setTimeout(() => { this.$router.reload('/huov/onHuov/' + this.huov_encrid); }, 2000);              
            this.$store.dispatch('setSnackbar', {
                showing: true,
                text: res.data.transferKlpt.text,
                color: res.data.transferKlpt.color
            }); 
            this.loading = false;
            this.dialog = false;
          }
        })
    },
  }
}
</script>

